export default __webpack_public_path__ + "static/media/02.6ebc9e98.png";